<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense class="dialog-header primary">
        <v-toolbar-title  class="white--text headline font-weight-medium">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
            icon
            @click="fullscreen=!fullscreen"
            class="white--text"
        >
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider  class="divider-gradient"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text class="dialog-content">
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  autofocus
                  label="论文标题"
                  required
                  :rules="rules.required"
                  v-model="item.title"
                />
              </v-flex>

              <v-flex xs12 sm7>
                <v-select
                  label="校内主管部门"
                  clearable
                  required
                  :rules="rules.required"
                  v-model="item.adminDeptId"
                  item-text="name"
                  item-value="dbid"
                  :items="adminDeptItems"
                />
              </v-flex>

              <v-flex xs12 sm5>
                <v-menu
                  ref="menuPublDate"
                  :close-on-content-click="false"
                  v-model="menuPublDate"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="item.publDate"
                    label="发表时间"
                    :rules="rules.publDate"
                    hint="格式YYYY-MM, 如：2018-10"
                    persistent-hint
                  />
                  <v-date-picker
                    v-model="publDate"
                    type="month"
                    locale="zh-cn"
                    @change="nv => item.publDate = nv"
                  />
                </v-menu>
              </v-flex>

              <v-flex xs12>
                <x-journal
                  label="期刊"
                  v-model="journal"
                  :pub-date="item.publDate"
                  @input="(v) => Object.assign(item, v)"
                />
              </v-flex>

              <v-flex xs12 sm3>
                <v-text-field
                  label="卷"
                  required
                  :rules="rules.required"
                  v-model="item.volume"
                />
              </v-flex>

              <v-flex xs12 sm3>
                <v-text-field
                  label="期"
                  required
                  :rules="rules.required"
                  v-model="item.number"
                />
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                  label="页码"
                  required
                  v-model="item.pages"
                />
              </v-flex>

              <v-flex xs12>
                <x-authors
                  label="作者列表"
                  v-model="item.authors"
                  hint="填写作者列表"
                />

              </v-flex>

              <v-flex xs12 sm4>
                <v-select
                  :items="instRankItems"
                  v-model="item.institutionRank"
                  label="单位署名"
                  :rules="rules.institutionRank"
                  clearable
                />
              </v-flex>

              <v-flex xs12 sm8>
                <v-autocomplete
                  item-text="name"
                  item-value="dbid"
                  :items="deptItems"
                  v-model="item.deptId"
                  label="归属部门"
                  :rules="rules.required"
                  clearable
                />
              </v-flex>

              <v-flex xs12>
                <v-autocomplete
                  item-text="name"
                  item-value="dbid"
                  :items="subjectItems"
                  v-model="item.subjectId"
                  label="学科分类"
                  :rules="rules.required"
                  hint="所属一级学科分类"
                  persistent-hint
                  clearable
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field label="备注" v-model="item.note"/>
              </v-flex>

              <v-flex xs12>
                <x-uploader
                  label="附件列表"
                  :action="fileUri"
                  v-model="item.attachments"
                  :size="Number(50)"
                  description="单个附件大小不超过 50M."
                />
              </v-flex>

            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions class="dialog-actions glassmorphism">
        <v-spacer/>
        <v-btn
            color="grey lighten-1"
            text
            @click.native="visible = false"
            class="action-btn mr-3"
        >
          <v-icon left>close</v-icon>
          取消
        </v-btn>
        <v-btn
            color="primary"
            @click.native="onCheck"
            class="action-btn elevation-0"
            dark
            depressed
        >
          <v-icon left>check</v-icon>
          保存
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="showAlert" max-width="700px" persistent>
      <v-card class="modern-card">
        <div class="modern-header">
          <v-icon color="white" large>mdi-file-document-alert</v-icon>
          <h2 class="modern-title">论文重复登记提醒</h2>
        </div>

        <v-card-text class="modern-content">
          <div class="modern-message">
            <p class="modern-text">您尝试登记的论文：</p>
            <div class="modern-highlight">
              <p class="modern-paper-title">{{ paperTitle }}</p>
            </div>

            <v-divider class="my-4"/>

            <p class="modern-text">该论文已被以下作者(显示格式：部门 姓名(排名))登记</p>
            <div class="modern-authors">
              <p>{{ paperAuthors }}</p>
            </div>

            <div class="modern-alert mt-4">
              <v-icon color="error" small>mdi-alert-circle</v-icon>
              <span>系统不允许论文重复登记,请联系登记该论文的老师或学院科研秘书处理。</span>
            </div>

          </div>
        </v-card-text>

        <v-card-actions class="modern-actions">
          <v-spacer/>
          <v-btn
              color="#4a6baf"
              dark
              depressed
              @click="showAlert = false; paperHave = true"
              class="modern-btn"
          >
            确认
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'
  import XAuthors from './widgets/Authors'
  import XJournal from './widgets/Journal'

  import XUploader from '@/components/global/Uploader'

  const baseUri = '/api/papr/paper';
  const deptUri = '/api/syst/department';
  const subjectUri = '/api/code/subject';
  const checkPaperHaveUri = '/api/papr/paper/check/paper/have';

  export default {
    mixins: [mixin.edit(baseUri)],
    components: {XAuthors, XJournal, XUploader},
    data() {
      return {
        formValid: false,

        fileUri: '/api/papr/file',

        item: {},
        freshItem: {
          "title": null,
          "journalId": null,
          "volume": null,
          "number": null,
          "publDate": null,
          "pages": null,
          "url": null,
          "deptId": null,
          "statusId": null,
          "subjectId": null,
          "category": 'J',
          "publication": null,
          "levelId": null,
          "institutionRank": null,
          "organizer": null,
          "address": null,
          "note": null,

          "authors": [],
          "level": null,
          "indexings": []
        },

        journal: {
          journalId: null,
          publication: null,
          levelId: null,
          indexIds: [],

          levelName: null,
          indexNames: null
        },

        menuPublDate: false,
        publDate:null,

        showAlert: false,
        paperHave: false,
        paperTitle: '',
        paperAuthors: '',

        deptItems: [],
        adminDeptItems: [],
        subjectItems: [],
        instRankItems: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(
          v => {
            return {
              value: v,
              text: v <= 0 ? '未署名' : `第${v}单位`
            }
          }
        ),

        rules: {
          required: [
            v => !!v || '必填项。',
            v => (v && v.length <= 255) || '长度必须小于255个字符。'
          ],
          institutionRank: [
            v => (v >= 0) || '必填项。',
          ],

          publDate: [
            v => !!v || "必填项。",
            v => window.xutil.regexpMonth().test(v) || '日期格式错误'
          ],
        }
      }
    },

    created() {
      this.axios.all([
        this.axios.get(deptUri, {params: {limit: 65535, disabled: 'F'}}),
        this.axios.get(subjectUri, {params: {limit: 65535, disabled: 'F', codeIsNotNull: true, sort: 'order.asc'}}),
      ]).then(
        this.axios.spread(
          (rspDept, rspSubj) => {
            this.deptItems = rspDept.data.items;
            this.subjectItems = rspSubj.data.items;

            this.adminDeptItems = rspDept.data.items
              .filter(v => v.isAdmin && (!/公司$/ig.test(v.name)))
              .reverse();
          }
        )
      )
    },

    watch: {},
    methods: {
      // mixin 加载数据后调用
      afterGetData(data) {
        let jour = {};
        ['journalId', 'publication', 'levelId'].forEach(v => jour[v] = data[v]);
        jour.levelName = data.level ? data.level.name : null;
        jour.indexNames = (data.indexings || []).map(v => v.name).join(', ');
        jour.indexIds = (data.indexings || []).map(v => v.dbid);

        this.journal = jour;

        data.publDate = data.publDate.substring(0, 7)
      },

      async onCheck() {
        //如果新登记论文，则进行查重判断后再进行保存，否则直接保存
        if (!this.dbid || this.dbid.length === 0) {
          //采取异步方式判断论文标题是否重复，必需等待判断结果
          await this.onCheckPaperHave()
          if (!this.paperHave)
          {
            this.onSave()
          }
        }
        else
        {
          this.onSave()
        }
      },

      async onCheckPaperHave() {
        const vm = this
        await this.axios.get(checkPaperHaveUri,{
          params: {
            title: vm.item.title.replace(/\s+/g, '').toLowerCase()
          }
        })
            .then(rsp => {
              if (rsp.data.found === "false") {
                vm.paperHave = false
              }
              else
              {
                vm.paperTitle = vm.item.title
                vm.paperAuthors = rsp.data.authors.map(a => `${a.deptName} ${a.name}(${a.rank})`).join(',')
                vm.showAlert = true
                vm.paperHave = true
              }
            })
      }
    }
  }
</script>

<style>
.modern-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.modern-header {
  align-items: center;
  background: linear-gradient(135deg, #4a6baf 0%, #2c3e50 100%);
  color: white;
  padding: 13px 24px;
  text-align: center;
}

.modern-title {
  font-weight: 500;
  margin-top: 8px;
  letter-spacing: 0.5px;
}

.modern-content {
  padding: 24px;
  background-color: #f9fafc;
}

.modern-message {
  max-width: 90%;
  margin: 0 auto;
}

.modern-text {
  color: #5a6a85;
  margin-bottom: 12px;
  font-size: 1rem;
}

.modern-highlight {
  background-color: #f0f4ff;
  border-left: 3px solid #4a6baf;
  padding: 12px 16px;
  margin: 16px 0;
  border-radius: 0 4px 4px 0;
}

.modern-paper-title {
  color: #2c3e50;
  font-weight: 500;
  margin: 0;
  line-height: 1.5;
}

.modern-authors {
  background-color: #f5f7fa;
  padding: 12px 16px;
  border-radius: 4px;
  color: #4a5568;
  font-size: 1rem;
}

.modern-alert {
  display: flex;
  align-items: center;
  color: #e53e3e;
  font-weight: 500;
  gap: 8px;
}

.modern-actions {
  padding: 16px 24px;
  background-color: #f0f4ff;
}


.modern-btn {
  min-width: 100px;
  text-transform: none;
  letter-spacing: 0.5px;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.2s;
}

.modern-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(74, 107, 175, 0.2);
}

/* 对话框整体样式 */
.professional-dialog {
  border-radius: 8px !important;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2) !important;
}

/* 标题栏样式 */
.dialog-header {
  background: linear-gradient(135deg, #00b4db 0%, #0083b0 100%);
  padding: 4px 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}

.divider-gradient {
  height: 2px;
  background: linear-gradient(90deg, rgba(66,165,245,1) 0%, rgba(66,165,245,0.5) 50%, rgba(66,165,245,0) 100%);
}

/* 内容区域样式 max-height调整窗口高度*/
.dialog-content {
  padding: 24px;
  background-color: #fafafa;
  min-height: 200px;
  max-height: 90vh;
  overflow-y: auto;
}

.glassmorphism {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  padding: 12px 24px !important;
}

/* 现代按钮样式 */
.action-btn {
  border-radius: 8px !important;
  height: 42px;
  padding: 0 20px;
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  text-transform: none;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

/* 主按钮悬浮效果 */
.action-btn.v-btn--contained:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2) !important;
}

/* 标题栏样式 */
.dialog-header {
  padding: 20px 24px 12px !important;
  position: relative;
}
</style>

